import store from '../store/store';
import { get, onValue } from "firebase/database";
import { firebase } from '../config/firebase.client';
import { getWeekNumber } from './earningreportsaction';
import { FETCH_DRIVERS_EARNING, FETCH_DRIVERS__EARNING_SUCCESS, FETCH_DRIVERS__EARNING_FAILED } from "../store/types";


interface FetchDriverEarningsProps {
  t: any;
  selectedDriverId?: string;
  fleetAdminId?: string | null;
  period?: "daily" | "monthly" | "yearly" | "weekly";
}

export const fetchDriverEarnings = ({ fleetAdminId = null, period = 'monthly', selectedDriverId, t }: FetchDriverEarningsProps) => async (dispatch: any) => {

  const {
    bookingListRef,
    settingsRef
  } = firebase;

  dispatch({
    type: FETCH_DRIVERS_EARNING,
    payload: null
  });

  const userInfo = store.getState().auth.profile;
  const settingsdata = await get(settingsRef);
  const settings = settingsdata.val();

  onValue(bookingListRef(userInfo.uid, userInfo.usertype), snapshot => {
    if (snapshot.val()) {
      let mainArr = Object.values(snapshot.val()) as any[];

      if (userInfo.usertype === 'fleetadmin') {
        mainArr = mainArr.filter((booking: any) => {
          return booking.fleetadmin && booking.fleetadmin.includes(userInfo.uid);
        });
      }

      if (fleetAdminId) {
        mainArr = mainArr.filter((booking: any) => {
          return booking.fleetadmin && booking.fleetadmin.includes(fleetAdminId);
        });
      }

      if (selectedDriverId) {
        mainArr = mainArr.filter((booking: any) => {
          return booking.driver === selectedDriverId;
        });
      }

      var monthsName = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];

      var renderobj: any = {};

      Object.keys(mainArr).map(j => {
        const booking = mainArr[j as any];

        if ((booking.status === 'PAID' || booking.status === 'COMPLETE') && booking.driver_share !== undefined) {
          let bdt = new Date(booking.tripdate);
          let uniqueKey = '';
          let displayLabel = '';

          switch (period) {
            case 'daily':
              uniqueKey = `${bdt.getFullYear()}_${bdt.getMonth()}_${bdt.getDate()}_${booking.driver}`;
              displayLabel = `${bdt.getDate()}/${bdt.getMonth() + 1}/${bdt.getFullYear()}`;
              break;
            case 'weekly':
              const weekNum = getWeekNumber(bdt);
              uniqueKey = `${bdt.getFullYear()}_W${weekNum}_${booking.driver}`;
              const weekText = t('week');
              displayLabel = `${weekText} ${weekNum} - ${bdt.getFullYear()}`;
              break;
            case 'yearly':
              uniqueKey = `${bdt.getFullYear()}_${booking.driver}`;
              displayLabel = `${bdt.getFullYear()}`;
              break;
            default:
              uniqueKey = `${bdt.getFullYear()}_${bdt.getMonth()}_${booking.driver}`;
              const monthKey = monthsName[bdt.getMonth()];
              const translatedMonth = t(monthKey);
              displayLabel = `${translatedMonth} ${bdt.getFullYear()}`;
              break;
          }

          if (renderobj[uniqueKey] && renderobj[uniqueKey].driverShare > 0) {
            renderobj[uniqueKey].driverShare = (parseFloat(renderobj[uniqueKey].driverShare) + parseFloat(booking.driver_share)).toFixed(settings.decimal);
            renderobj[uniqueKey]['total_rides'] = renderobj[uniqueKey]['total_rides'] + 1;
          } else {
            renderobj[uniqueKey] = {};
            renderobj[uniqueKey]['dated'] = booking.tripdate;
            renderobj[uniqueKey]['year'] = bdt.getFullYear();
            renderobj[uniqueKey]['month'] = bdt.getMonth();
            renderobj[uniqueKey]['monthsName'] = monthsName[bdt.getMonth()];
            renderobj[uniqueKey]['displayLabel'] = displayLabel;
            renderobj[uniqueKey]['driverName'] = booking.driver_name;
            renderobj[uniqueKey]['driverShare'] = parseFloat(booking.driver_share).toFixed(settings.decimal);
            renderobj[uniqueKey]['driverVehicleNo'] = booking.vehicle_number;
            renderobj[uniqueKey]['driverUId'] = booking.driver;
            renderobj[uniqueKey]['uniqueKey'] = uniqueKey;
            renderobj[uniqueKey]['total_rides'] = 1;
          }
        }
        return null;
      });

      if (renderobj) {
        const arr = Object.keys(renderobj).map(i => {
          renderobj[i].driverShare = parseFloat(renderobj[i].driverShare).toFixed(settings.decimal);
          return renderobj[i];
        });

        dispatch({
          type: FETCH_DRIVERS__EARNING_SUCCESS,
          payload: arr
        });
      }

    } else {
      dispatch({
        type: FETCH_DRIVERS__EARNING_FAILED,
        payload: "No data available."
      });
    }
  });
};